/*
 * ============================================================================
 * ============================================================================
 *
 * Controls the following homepage features:
 *
 * 1. Countdown
 * 2. Progress Bar
 * 3. Bonus-code popup and clipboard interaction
 * 4. GemPages homepage hero carousel
 * 5. Deferred hero-slide image loading
 * 6. Full-width autoplay progress pagination
 * 7. LGND+ Members Bonus strip (Meta glasses, Oct 8-11 2026)
 * 8. LGND+ Members Bonus countdown badge
 * 9. LGND+ Members Bonus reveal (A/B variant B)
 *
 * This file is home-page-script-103-launch.js with sections 7, 8 and 9 added
 * at the end. Sections 1-6 and the offer switcher are unchanged.
 */


/*
 * ============================================================================
 * 1. COUNTDOWN
 * ============================================================================
 */
const dayEl = document.querySelector('.day');
const hourEl = document.querySelector('.hour');
const minuteEl = document.querySelector('.minute');
const secondEl = document.querySelector('.second');

const countDate = new Date("October 25 2026 23:59:59 GMT-0400").getTime();
let countdownTimer = null;

function Countdown() {
  if (!dayEl || !hourEl || !minuteEl || !secondEl) return;

  const now = Date.now();
  // Hold at zero once the deadline passes instead of counting into negatives.
  const gap = Math.max(0, countDate - now);

  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const textDay = Math.floor(gap / day);
  const textHour = Math.floor((gap % day) / hour);
  const textMinute = Math.floor((gap % hour) / minute);
  const textSecond = Math.floor((gap % minute) / second);

  const pad = (num, digits = 2) => String(num).padStart(digits, "0");

  dayEl.textContent = pad(textDay);
  hourEl.textContent = pad(textHour);
  minuteEl.textContent = pad(textMinute);
  secondEl.textContent = pad(textSecond);

  // Stop ticking once the countdown reaches zero.
  if (gap === 0 && countdownTimer) {
    clearInterval(countdownTimer);
    countdownTimer = null;
  }
}

Countdown();

// Only start the interval if the deadline hasn't already passed.
if (countDate > Date.now()) {
  countdownTimer = setInterval(Countdown, 1000);
}







/*
 * ============================================================================
 * 2. PROGRESS BAR
 * ============================================================================
 */

const progress1 = document.querySelector(".progress1");
const progressBackground = document.querySelector(".progress-bg");
const progressBar = document.getElementById("progress-bar");

// Duration, in milliseconds, of the progress-fill width transition.
const transitionDuration = 750;


function getNewYorkTime() {
  const now = new Date();
  // Visitors current time
  const localTime = now.getTime();
  // Convert the visitor's timezone offset to milliseconds.
  const localOffset = now.getTimezoneOffset() * 60000;

  // Remove the visitor's local timezone offset to determine UTC time.
  const utcTime = localTime + localOffset;

  //Preserve the original fixed Eastern Standard Time offset.
  const offsetEST = -5;

  // Return the UTC time adjusted by the chosen Eastern offset.
  return new Date(utcTime + 3600000 * offsetEST);
}


// Progress Bar Dates
const beginTime = new Date("October 14, 2026 00:00:00").getTime();
const endTime = new Date("October 25, 2026 23:59:59").getTime();


// Calculate the complete campaign duration in milliseconds
const fullDuration = endTime - beginTime;

// Return the fraction of the campaign period that has elapsed.
function getProgressFraction() {
  const now = getNewYorkTime().getTime();
  return (now - beginTime) / fullDuration;
}


// Convert the elapsed campaign fraction into the displayed bar width.
function calculateWidth(fraction) {

  // Prevent a campaign that has not begun from displaying progress.
  if (fraction <= 0) return "0%";

  // Cap the completed campaign at 100%.
  if (fraction >= 1) return "100%";

  // Keep the progress bar hidden until 60% of the campaign has elapsed.
  if (fraction * 100 < 60) return "0%";

  // 60% threshold is reached: map the full campaign fraction into the final 40% of the visible bar
  return 60 + fraction * 40 + "%";

  // Alternatively: To display the literal elapsed percentage instead, the line above could be replaced with:
  // return fraction * 100 + "%";
}



// Initialize the Progress Bar
function initProgressBar() {
  // Exit function if elements do not exist
  if (!progressBackground || !progress1) return;

  // Calculate the campaign's current progress.
  const fraction = getProgressFraction();  
  // console.log(fraction);

  // Convert that fraction into the appropriate CSS width.
  const width = calculateWidth(fraction);

  /*
   * Keep the progress bar hidden when:
   * - The campaign has not started
   * - The campaign has ended
   * - Less than 60% of the campaign has elapsed
   */
  if (
    fraction <= 0 ||
    fraction >= 1 ||
    fraction * 100 < 60
  ) {
    return;
  }

   // Allow the initial page layout to render before expanding the bar.
  setTimeout(() => {
    // Reveal the progress bar track and fill.
    progressBackground.style.height = "15px";
    progress1.style.height = "15px";

    // Wait briefly before animating the fill to its current position.
    setTimeout(() => {
      progress1.style.width = width;
    }, 250);

    // Begin live progress updates after the initial width animation finishes.
    setTimeout(
      startLiveProgressUpdates,
      transitionDuration + 100
    );
  }, 100);
}

// Continue updating the campaign progress bar after its entrance animation.
function startLiveProgressUpdates() {
  if (!progress1) return;

  setInterval(() => {
    const fraction = getProgressFraction();
    const width = calculateWidth(fraction);

    progress1.style.width = width;
    requestAnimationFrame(() => {
      progress1.style.transition =
        "width .75s ease-in-out";
    });
  }, 1000);
}

initProgressBar();






/*
 * ============================================================================
 * 3. BONUS-CODE POPUP CONTROLS
 * ============================================================================
 */

/*
 * Wait until the page markup has been parsed before locating and attaching
 * popup controls.
 */
window.addEventListener("DOMContentLoaded", () => {
  const sideBar = document.getElementById("popUpTrigger");
  const banners = document.querySelectorAll(".popUpTrigger");
  const popup = document.getElementById("fs-popup");
  const closeBtn = document.getElementById("exit-icon");
  const copyBox = document.getElementById("copyBox");
  const bonusCode = document.getElementById("bonusCode");
  const successMsg = document.getElementById("successMsg");
  let popupContent = null;

  if (popup) {
    popupContent = popup.querySelector(
      ".bonus-popup-content"
    );
  }

  /*
   * Store the ID of any pending automatic-close timer.
   * This allows an old timer to be cancelled before starting a new one.
   */
  let autoCloseTimeout = null;

  // Close the popup with fade and zoom-out animations.
  function closePopup() {
    if (!popup || !popupContent || !successMsg) return;
    clearTimeout(autoCloseTimeout);
    successMsg.classList.add("hidden");
    popup.classList.add("closing");
    popupContent.classList.add("closing");
    setTimeout(() => {
      popup.classList.remove("show", "closing");
      popupContent.classList.remove("closing");
    }, 300);
  }

  // Attach an open action to every popup trigger.
  banners.forEach((banner) => {
    banner.addEventListener("click", () => {
      // Exit function if the required popup markup is unavailable.
      if (!popup || !successMsg) return;

      // Prevent an earlier clipboard action from closing the newly opened popup.
      clearTimeout(autoCloseTimeout);

      // Reset the success message whenever the popup is opened.
      successMsg.classList.add("hidden");

      // Remove the class that keeps the popup hidden.
      popup.classList.remove("hidden");

      // Apply the visible/entrance-animation class.
      popup.classList.add("show");
    });
  });

  // Close the popup when the X button is clicked.
  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  // Close the popup when the visitor clicks directly on the overlay outside the inner popup content.
  if (popup) {
    popup.addEventListener("click", (event) => {
      if (event.target === popup) {
        closePopup();
      }
    });
  }

  // Copy the code when copy box is clicked.
  if (copyBox && bonusCode && successMsg) {
    copyBox.addEventListener("click", async () => {
      try {
         // Copy the displayed bonus-code text to the visitor's clipboard.
        await navigator.clipboard.writeText(
          bonusCode.textContent
        );

        // Reveal the successful-copy message.
        successMsg.classList.remove("hidden");

        // Cancel any older automatic-close timer.
        clearTimeout(autoCloseTimeout);

        // Automatically close the popup five seconds after the successful clipboard action.
        autoCloseTimeout = setTimeout(() => {
          closePopup();
        }, 5000);
      } catch (error) {
        // Report clipboard permission or browser-support failures without stopping the rest of the homepage script.
        console.error(
          "Clipboard copy failed:",
          error
        );
      }
    });
  }
});


/*
 * ============================================================================
 * 4. GEMPAGES HOMEPAGE HERO
 * ============================================================================
 *
 * This feature is wrapped in an immediately invoked function expression.
 *
 * That keeps its internal variables and functions out of the global scope and
 * prevents them from conflicting with other theme or GemPages scripts.
 */

(function () {
  // locate every homepage hero instance.
  const heroSelector = "[data-gp-home-hero]";

  // Converts an HTML data-attribute string into a real Boolean value.
  // If the value is neither "true" nor "false", return the supplied fallback.

  function parseBoolean(value, fallback) {
    if (value === "true") return true;
    if (value === "false") return false;

    return fallback;
  }

  // Clamp a numeric value between a minimum and maximum.
  // The pagination system uses this to ensure that progress never falls below  0 or rises above 1.
  function clamp(value, minimum, maximum) {
    return Math.min(
      Math.max(value, minimum),
      maximum
    );
  }

  /*
   * Activate an image that was intentionally deferred.
   *
   * Future image slides can place their real image URLs in:
   *
   * data-gp-src
   * data-gp-srcset
   * data-gp-srcset on a <source> element
   *
   * The browser will not request those images until this function activates
   * the relevant slide.
   */
  function activateDeferredPicture(slide, splide) {
    /*
     * Stop if no slide was supplied.
     */
    if (!slide) return;

    /*
     * Find a deferred <picture> element inside the slide.
     */
    const picture = slide.querySelector(
      "[data-gp-deferred-picture]"
    );

    /*
     * Stop if the slide's picture has already loaded or was not deferred.
     */
    if (!picture) return;

    /*
     * Move each deferred <source> srcset into its real srcset attribute.
     */
    picture
      .querySelectorAll("source[data-gp-srcset]")
      .forEach(function (source) {
        source.srcset = source.dataset.gpSrcset;
        source.removeAttribute("data-gp-srcset");
      });

    /*
     * Locate the deferred fallback <img>.
     */
    const image = picture.querySelector(
      "img[data-gp-src]"
    );

    /*
     * Activate the fallback image if it exists.
     */
    if (image) {
      /*
       * Refresh Splide once the newly activated image finishes loading.
       *
       * This allows autoHeight and other slide measurements to remain correct.
       */
      image.addEventListener(
        "load",
        function () {
          splide.refresh();
        },
        { once: true }
      );

      /*
       * Activate the image's responsive srcset when one was deferred.
       */
      if (image.dataset.gpSrcset) {
        image.srcset = image.dataset.gpSrcset;
        image.removeAttribute("data-gp-srcset");
      }

      /*
       * Activate the image's primary src URL.
       */
      image.src = image.dataset.gpSrc;
      image.removeAttribute("data-gp-src");
    }

    /*
     * Mark the picture as activated so it will not be processed again.
     */
    picture.removeAttribute(
      "data-gp-deferred-picture"
    );
  }

  /*
   * Prepare the next hero slide during an idle browser period.
   *
   * Preloading one slide ahead avoids requesting every hero image immediately
   * while still making the next transition feel instantaneous.
   */
  function prepareNextSlide(
    slides,
    currentIndex,
    rewind,
    splide
  ) {
    /*
     * Define the image-preparation work separately so it can run either through
     * requestIdleCallback or setTimeout.
     */
    const prepare = function () {
      /*
       * Start with the slide immediately following the current slide.
       */
      let nextIndex = currentIndex + 1;

      /*
       * Handle reaching the final slide.
       */
      if (nextIndex >= slides.length) {
        /*
         * Do not prepare the first slide when carousel rewinding is disabled.
         */
        if (!rewind) return;

        /*
         * When rewinding is enabled, prepare slide zero as the next slide.
         */
        nextIndex = 0;
      }

      /*
       * Activate the next slide's deferred image.
       */
      activateDeferredPicture(
        slides[nextIndex],
        splide
      );
    };

    /*
     * Use the browser's idle callback when supported so the preload work does
     * not compete with more important rendering work.
     */
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(prepare, {
        timeout: 1200
      });
    } else {
      /*
       * Use a short timeout as the fallback for browsers without
       * requestIdleCallback.
       */
      window.setTimeout(prepare, 250);
    }
  }

  /*
   * Initialize one GemPages homepage hero.
   */
  function initializeHero(hero) {
    if (
      hero.dataset.gpHeroInitialized === "true"
    ) {
      return;
    }

    /*
     * Wait to initialize until the Splide library is available.
     */
    if (typeof window.Splide !== "function") {
      return;
    }

    /*
     * Collect the hero's original slide elements.
     */
    const slides = Array.from(
      hero.querySelectorAll(".splide__slide")
    );

    /*
     * Do not initialize an empty hero.
     */
    if (!slides.length) return;
    const hasOneSlide = slides.length === 1;

    /*
     * Enable rewinding only when requested and when multiple slides exist.
     */
    const rewind =
      parseBoolean(
        hero.dataset.rewind,
        true
      ) && !hasOneSlide;

    /*
     * Enable autoplay only when requested and when multiple slides exist.
     */
    const autoplay =
      parseBoolean(
        hero.dataset.autoplay,
        true
      ) && !hasOneSlide;

    /*
     * Enable arrows only when requested and when multiple slides exist.
     */
    const arrows =
      parseBoolean(
        hero.dataset.showArrows,
        true
      ) && !hasOneSlide;

    /*
     * Enable pagination only when requested and when multiple slides exist.
     *
     * Splide still creates the pagination buttons. CSS converts those buttons
     * into the custom full-width progress bars.
     */
    const pagination =
      parseBoolean(
        hero.dataset.showTabs,
        true
      ) && !hasOneSlide;

    /*
     * Read the autoplay duration from the hero's data attribute.
     *
     * Use 6000 milliseconds if the attribute is absent or invalid.
     */
    const interval =
      Number.parseInt(
        hero.dataset.autoplayDelay,
        10
      ) || 6000;

    hero.dataset.singleSlide =
      String(hasOneSlide);

    hero.dataset.gpHeroInitialized = "true";

    /*
     * Create the Splide carousel.
     */
    const splide = new window.Splide(hero, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      autoHeight: true,
      rewind: rewind,
      rewindByDrag: rewind,
      drag: !hasOneSlide,
      arrows: arrows,
      pagination: pagination,
      paginationKeyboard: true,
      autoplay: autoplay,
      interval: interval,
      pauseOnHover: false,
      pauseOnFocus: true,
      resetProgress: false,
      speed: 500,
      waitForTransition: false,
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
      }
    });

    /*
     * Return all pagination buttons currently generated by Splide.
     *
     * Splide does not create these elements until its pagination component has
     * mounted, so this function queries them each time they are needed.
     */
    function getPaginationButtons() {
      return Array.from(
        hero.querySelectorAll(
          ".splide__pagination__page"
        )
      );
    }

    /*
     * Update the full-width pagination progress bars.
     *
     * The CSS reads the --gp-hero-progress custom property and uses it to scale
     * the active bar's ::after filling layer from left to right.
     */
    function updateProgressBars(
      activeIndex,
      progress
    ) {
      /*
       * Collect Splide's current pagination buttons.
       */
      const buttons = getPaginationButtons();
      const safeProgress = clamp(
        Number(progress) || 0,
        0,
        1
      );

      /*
       * Update each pagination bar according to its position relative to the
       * current slide.
       */
      buttons.forEach(function (button, index) {
        const isComplete = index < activeIndex;
        const isActive = index === activeIndex;

        /*
         * Apply or remove the completed-state class.
         *
         * The completed-state color is controlled through:
         *
         * --gp-hero-progress-filled-color
         */
        button.classList.toggle(
          "is-complete",
          isComplete
        );


        if (isActive) {
          button.style.setProperty(
            "--gp-hero-progress",
            String(safeProgress)
          );
        } else {
          button.style.setProperty(
            "--gp-hero-progress",
            "0"
          );
        }
      });
    }

    /*
     * Initialize the progress bars as soon as Splide creates its pagination.
     */
    splide.on(
      "pagination:mounted",
      function () {
        updateProgressBars(
          splide.index,
          autoplay ? 0 : 1
        );
      }
    );

    /*
     * Synchronize the active progress bar with Splide's real autoplay timer.
     *
     * Splide supplies a rate between 0 and 1:
     *
     * 0   = the autoplay interval has just begun
     * 0.5 = half of the interval has elapsed
     * 1   = Splide is ready to advance
     */
    splide.on(
      "autoplay:playing",
      function (rate) {
        updateProgressBars(
          splide.index,
          rate
        );
      }
    );

    /*
     * Reset and rearrange the progress bars as soon as movement toward another
     * slide begins.
     *
     * This covers:
     *
     * - Autoplay
     * - Arrow clicks
     * - Pagination clicks
     * - Swipe/drag navigation
     */
    splide.on(
      "move",
      function (newIndex) {
        updateProgressBars(
          newIndex,
          autoplay ? 0 : 1
        );
      }
    );

    /*
     * Confirm the progress-bar state when the slide transition finishes.
     */
    splide.on(
      "moved",
      function (newIndex) {
        updateProgressBars(
          newIndex,
          autoplay ? 0 : 1
        );
      }
    );

    /*
     * Load the active slide and prepare the next slide whenever the carousel
     * mounts or begins moving.
     */
    splide.on(
      "mounted move",
      function (newIndex) {
        const activeIndex =
          Number.isInteger(newIndex)
            ? newIndex
            : splide.index;

        /*
         * Activate the current slide's deferred image if necessary.
         */
        activateDeferredPicture(
          slides[activeIndex],
          splide
        );

        /*
         * Prepare the following slide during an idle period.
         */
        prepareNextSlide(
          slides,
          activeIndex,
          rewind,
          splide
        );
      }
    );

    splide.mount();
  }

  /*
   * Initialize every qualifying homepage hero on the current page.
   *
   * Return true once Splide is available, even when no matching heroes exist.
   */
  function initializeAllHeroes() {
    if (typeof window.Splide !== "function") {
      return false;
    }

    /*
     * Initialize every hero that has not already been mounted.
     */
    document
      .querySelectorAll(heroSelector)
      .forEach(initializeHero);
    return true;
  }

  /*
   * Wait for the deferred Splide script to become available.
   */
  function waitForSplide(attempt) {
    if (initializeAllHeroes()) return;

    /*
     * Stop after 50 attempts.
     *
     * At 100 milliseconds per attempt, this gives Splide approximately five
     * seconds to load.
     */
    if (attempt >= 50) return;

    /*
     * Try again after 100 milliseconds.
     */
    window.setTimeout(function () {
      waitForSplide(attempt + 1);
    }, 100);
  }


  function start() {
    waitForSplide(0);
  }

  /*
   * Wait for DOMContentLoaded when the page is still being parsed.
   */
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }

  /*
   * Re-run initialization when Shopify dynamically reloads a section in the
   * Theme Editor.
   *
   * Existing heroes are protected from duplicate initialization by the
   * data-gp-hero-initialized attribute.
   */
  document.addEventListener(
    "shopify:section:load",
    start
  );
})();

/*
 * LGND HOME WINNERS MARQUEE
 */

(function () {
  const selector = "[data-lgnd-winners-marquee]";
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  const canHover = window.matchMedia(
    "(hover: hover) and (pointer: fine)"
  ).matches;

  function mountMarquee(root) {
    if (root.dataset.lgndWinnersInitialized === "true") return;

    root.dataset.lgndWinnersInitialized = "true";

    const splide = new window.Splide(root, {
      type: "loop",
      autoWidth: true,
      gap: "16px",
      drag: "free",
      snap: false,
      arrows: false,
      pagination: false,
      keyboard: false,

      autoScroll: {
        speed:
          Number.parseFloat(root.dataset.autoScrollSpeed) || 0.85,
        autoStart: !reduceMotion,
        pauseOnHover: canHover,
        pauseOnFocus: true
      },

      breakpoints: {
        749: {
          gap: "10px"
        }
      }
    });

    splide.mount({
      AutoScroll: window.splide.Extensions.AutoScroll
    });

    root.lgndWinnersSplide = splide;

    /*
     * Stop the marquee while it is outside the viewport.
     */
    if (!reduceMotion && "IntersectionObserver" in window) {
      const autoScroll = splide.Components.AutoScroll;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            autoScroll.play();
          } else {
            autoScroll.pause();
          }
        },
        {
          rootMargin: "160px 0px"
        }
      );

      observer.observe(root);

      splide.on("destroy", () => {
        observer.disconnect();
      });
    }
  }

  /*
   * Wait for both Splide and its AutoScroll extension.
   */
  function initialize(attempt = 0) {
    const autoScroll =
      window.splide?.Extensions?.AutoScroll;

    if (
      typeof window.Splide !== "function" ||
      !autoScroll
    ) {
      if (attempt < 60) {
        window.setTimeout(() => {
          initialize(attempt + 1);
        }, 100);
      }

      return;
    }

    document
      .querySelectorAll(selector)
      .forEach(mountMarquee);
  }

  // initialize();

  /*
   * Mount the marquee only after the page has loaded and the marquee is
   * within 400px of the viewport, so it never competes with first paint.
   */
  function initializeWhenNear() {
    const roots = document.querySelectorAll(selector);
    if (!roots.length) return;

    if (!("IntersectionObserver" in window)) {
      initialize();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          initialize();
        }
      },
      { rootMargin: "400px 0px" }
    );

    roots.forEach((root) => observer.observe(root));
  }

  if (document.readyState === "complete") {
    initializeWhenNear();
  } else {
    window.addEventListener("load", initializeWhenNear, { once: true });
  }

  /*
   * Support section reloading inside Shopify's Theme Editor.
   */
  document.addEventListener(
    "shopify:section:load",
    () => initialize()
  );

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      event.target
        .querySelectorAll(selector)
        .forEach((root) => {
          root.lgndWinnersSplide?.destroy(true);
        });
    }
  );
})();























// /* LGND offer switcher 
//  * Uses the cart section/event contract verified in your uploaded Prestige theme.
//  * The forms deliberately are NOT wrapped in <product-form>: only this handler
//  * submits them, preventing a duplicate add from Prestige's native form handler.
//  *//* LGND offer switcher — REPLACE the previous switcher code.
//  * Paste into your deferred homepage JavaScript without <script> tags.
//  */
// (() => {
//   'use strict';

//   if (customElements.get('lgnd-offer-switcher')) return;

//   // Timing settings, in milliseconds.
//   const MEMBER_SWITCH_DELAY = 2000;
//   const FAST_PASS_RESET_DELAY = 1500;

//   let instanceCount = 0;

//   class LGNDOfferSwitcher extends HTMLElement {
//     connectedCallback() {
//       queueMicrotask(() => {
//         if (!this.isConnected || this.controller) return;

//         this.controller = new AbortController();

//         const options = { signal: this.controller.signal };

//         this.selected = this.dataset.selected || 'fast';
//         this.busy = false;
//         this.animating = false;
//         this.memberInCart = false;
//         this.membershipChecking = true;
//         this.fastAdded = false;
//         this.cartRevision = 0;

//         this.tabs = [...this.querySelectorAll('[data-select]')];
//         this.cards = [...this.querySelectorAll('[data-card]')];
//         this.panels = [...this.querySelectorAll('[data-panel]')];
//         this.forms = [...this.querySelectorAll('[data-offer-form]')];

//         this.status = this.querySelector('[data-status]');
//         this.cartLink = this.querySelector('[data-cart-link]');
//         this.motion = matchMedia('(prefers-reduced-motion: reduce)');

//         this.memberForm = this.querySelector(
//           '[data-panel="plus"] [data-offer-form]'
//         );

//         this.memberVariantId = this.memberForm
//           .querySelector('[name="id"]').value;

//         const prefix = `lgnd-offer-${++instanceCount}`;

//         this.tabs.forEach(tab => {
//           const panel = this.panels.find(
//             item => item.dataset.panel === tab.dataset.select
//           );

//           tab.id = `${prefix}-${tab.dataset.select}-button`;
//           panel.id = `${prefix}-${tab.dataset.select}-panel`;

//           tab.setAttribute('aria-controls', panel.id);
//           panel.setAttribute('role', 'region');
//           panel.setAttribute('aria-labelledby', tab.id);

//           tab.addEventListener(
//             'click',
//             () => this.select(tab.dataset.select),
//             options
//           );
//         });

//         this.cards.forEach(card => {
//           card.addEventListener(
//             'click',
//             () => this.select(card.dataset.card),
//             options
//           );
//         });

//         this.forms.forEach(form => {
//           const label = form.querySelector('[data-button-label]');

//           if (!label.dataset.idle) {
//             label.dataset.idle = label.textContent;
//           }

//           form.addEventListener(
//             'submit',
//             event => {
//               event.preventDefault();
//               this.addToCart(form);
//             },
//             options
//           );
//         });

//         this.setBusy(false);
//         this.renderSelection();

//         // Track membership additions/removals throughout the theme.
//         const onCartUpdate = event => {
//           if (Array.isArray(event.detail?.cart?.items)) {
//             this.updateFromCart(event.detail.cart);
//           } else {
//             this.queueCartRead();
//           }
//         };

//         ['cart:change', 'variant:add', 'line-item:change'].forEach(name => {
//           document.addEventListener(name, onCartUpdate, options);
//         });

//         ['cart:refresh', 'cart-drawer:refreshed'].forEach(name => {
//           document.addEventListener(
//             name,
//             () => this.queueCartRead(),
//             options
//           );
//         });

//         window.addEventListener(
//           'pageshow',
//           () => this.queueCartRead(),
//           options
//         );

//         // Restore the correct membership button state on page load.
//         this.readCart();
//       });
//     }

//     disconnectedCallback() {
//       this.controller?.abort();
//       this.controller = null;

//       clearTimeout(this.memberSwitchTimer);
//       clearTimeout(this.fastResetTimer);
//       clearTimeout(this.cartReadTimer);

//       this.cartRevision++;

//       this.getAnimations({ subtree: true }).forEach(animation => {
//         animation.cancel();
//       });

//       // Do not abort an in-flight add: Shopify may already have processed it.
//     }

//     renderSelection() {
//       this.dataset.selected = this.selected;

//       this.tabs.forEach(tab => {
//         tab.setAttribute(
//           'aria-pressed',
//           String(tab.dataset.select === this.selected)
//         );
//       });

//       this.cards.forEach(card => {
//         const active = card.dataset.card === this.selected;

//         card.dataset.front = String(active);
//         card.setAttribute('aria-pressed', String(active));
//       });

//       this.panels.forEach(panel => {
//         const active = panel.dataset.panel === this.selected;

//         panel.inert = !active;
//         panel.setAttribute('aria-hidden', String(!active));
//       });
//     }

//     async select(next, automatic = false) {
//       // A manual selection overrides the delayed automatic switch.
//       if (!automatic) {
//         clearTimeout(this.memberSwitchTimer);
//       }

//       if (this.busy || !['fast', 'plus'].includes(next)) return;

//       if (this.animating) {
//         this.queued = next;
//         return;
//       }

//       if (next === this.selected) return;

//       this.message('');

//       const outgoing = this.cards.find(
//         card => card.dataset.card === this.selected
//       );

//       const incoming = this.cards.find(
//         card => card.dataset.card === next
//       );

//       const oldFront = getComputedStyle(outgoing).transform;
//       const oldBack = getComputedStyle(incoming).transform;

//       const distance =
//         this.getBoundingClientRect().right -
//         outgoing.getBoundingClientRect().left +
//         outgoing.offsetWidth;

//       const outside =
//         `translate(${distance}px, -50%) rotate(15deg) scale(.94)`;

//       this.animating = true;

//       const animations = [];

//       try {
//         // Update the offer while preserving the outgoing image's position.
//         this.selected = next;
//         this.dataset.selected = next;

//         this.tabs.forEach(tab => {
//           tab.setAttribute(
//             'aria-pressed',
//             String(tab.dataset.select === next)
//           );
//         });

//         this.panels.forEach(panel => {
//           panel.inert = panel.dataset.panel !== next;

//           panel.setAttribute(
//             'aria-hidden',
//             String(panel.dataset.panel !== next)
//           );
//         });

//         if (this.motion.matches || !outgoing.animate) {
//           this.renderSelection();
//           return;
//         }

//         const out = outgoing.animate(
//           [
//             { transform: oldFront },
//             { transform: outside }
//           ],
//           {
//             duration: 250,
//             easing: 'cubic-bezier(.5,0,.8,.5)',
//             fill: 'forwards'
//           }
//         );

//         animations.push(out);

//         await out.finished;

//         this.renderSelection();
//         out.cancel();

//         // Final positions come from the existing CSS.
//         const rear = getComputedStyle(outgoing).transform;
//         const front = getComputedStyle(incoming).transform;

//         const backIn = outgoing.animate(
//           [
//             { transform: outside },
//             { transform: rear }
//           ],
//           {
//             duration: 350,
//             easing: 'cubic-bezier(.2,.8,.2,1)'
//           }
//         );

//         const forward = incoming.animate(
//           [
//             {
//               transform: oldBack,
//               filter: 'brightness(.65)'
//             },
//             {
//               transform: front,
//               filter: 'brightness(1)'
//             }
//           ],
//           {
//             duration: 350,
//             easing: 'cubic-bezier(.2,.8,.2,1)'
//           }
//         );

//         animations.push(backIn, forward);

//         await Promise.all([
//           backIn.finished,
//           forward.finished
//         ]);
//       } catch (error) {
//         if (error.name !== 'AbortError') {
//           console.warn('LGND card animation:', error);
//         }
//       } finally {
//         animations.forEach(animation => animation.cancel());

//         this.renderSelection();
//         this.animating = false;

//         const queued = this.queued;
//         this.queued = null;

//         if (queued && this.isConnected) {
//           this.select(queued);
//         }
//       }
//     }

//     setBusy(busy, activeForm) {
//       this.busy = busy;
//       this.activeForm = busy ? activeForm : null;

//       this.tabs.forEach(tab => {
//         tab.disabled = busy;
//       });

//       this.cards.forEach(card => {
//         card.disabled = busy;
//       });

//       this.updateButtons();
//     }

//     updateButtons() {
//       this.forms.forEach(form => {
//         const button = form.querySelector('[type="submit"]');
//         const label = button.querySelector('[data-button-label]');

//         const membership = form === this.memberForm;
//         const loading = this.busy && form === this.activeForm;
//         const added = membership ? this.memberInCart : this.fastAdded;

//         const text = loading
//           ? 'Adding'
//           : added
//             ? 'Added to Cart'
//             : label.dataset.idle;

//         button.disabled =
//           this.busy ||
//           added ||
//           form.dataset.canBuy !== 'true' ||
//           (membership && this.membershipChecking);

//         button.setAttribute('aria-busy', String(loading));

//         // Keep the successful state fully visible while disabling another add.
//         button.style.opacity = added && !loading ? '1' : '';

//         const arrow = button.lastElementChild;

//         if (arrow !== label) {
//           arrow.hidden = loading || added;
//         }

//         // Avoid restarting the spinner when unrelated cart events arrive.
//         const state = `${loading}:${text}`;

//         if (label.dataset.state === state) return;

//         label.dataset.state = state;
//         label.spinnerAnimation?.cancel();
//         label.textContent = '';

//         if (loading) {
//           // Build the spinner here so no Liquid/CSS edits are required.
//           const spinner = document.createElement('span');

//           spinner.setAttribute('aria-hidden', 'true');
//           spinner.dataset.offerSpinner = '';

//           spinner.style.cssText =
//             'display:inline-block;' +
//             'width:14px;' +
//             'height:14px;' +
//             'margin-right:9px;' +
//             'vertical-align:-2px;' +
//             'border:2px solid currentColor;' +
//             'border-right-color:transparent;' +
//             'border-radius:50%;';

//           label.append(spinner);

//           if (!this.motion.matches) {
//             label.spinnerAnimation = spinner.animate(
//               [
//                 { transform: 'rotate(0deg)' },
//                 { transform: 'rotate(360deg)' }
//               ],
//               {
//                 duration: 650,
//                 iterations: Infinity,
//                 easing: 'linear'
//               }
//             );
//           }
//         }

//         label.append(document.createTextNode(text));
//       });
//     }

//     get cartRoot() {
//       return (
//         window.Shopify?.routes?.root ||
//         this.dataset.root ||
//         '/'
//       ).replace(/\/?$/, '/');
//     }

//     updateFromCart(cart) {
//       if (!Array.isArray(cart?.items)) return;

//       this.cartRevision++;
//       this.membershipChecking = false;

//       this.memberInCart = cart.items.some(item => {
//         return (
//           String(item.variant_id ?? item.id) === this.memberVariantId &&
//           Number(item.quantity ?? 1) > 0
//         );
//       });

//       if (!this.memberInCart) {
//         clearTimeout(this.memberSwitchTimer);
//       }

//       this.updateButtons();
//     }

//     queueCartRead() {
//       clearTimeout(this.cartReadTimer);

//       this.cartReadTimer = setTimeout(() => {
//         this.readCart();
//       }, 100);
//     }

//     async readCart() {
//       const revision = ++this.cartRevision;

//       try {
//         const response = await this.request(
//           `${this.cartRoot}cart.js`,
//           { cache: 'no-store' }
//         );

//         if (!response.ok) {
//           throw new Error('Cart lookup failed.');
//         }

//         const cart = await response.json();

//         // Ignore outdated reads when a newer cart event has already arrived.
//         if (this.isConnected && revision === this.cartRevision) {
//           this.updateFromCart(cart);
//         }
//       } catch (error) {
//         // Preserve the last known state when the cart lookup is unavailable.
//       } finally {
//         if (this.isConnected && revision === this.cartRevision) {
//           this.membershipChecking = false;
//           this.updateButtons();
//         }
//       }
//     }

//     showAddedState(form) {
//       if (form === this.memberForm) {
//         clearTimeout(this.memberSwitchTimer);

//         if (this.memberInCart) {
//           this.memberSwitchTimer = setTimeout(() => {
//             if (
//               this.isConnected &&
//               this.memberInCart &&
//               this.selected === 'plus'
//             ) {
//               this.select('fast', true);
//             }
//           }, MEMBER_SWITCH_DELAY);
//         }
//       } else {
//         this.fastAdded = true;

//         clearTimeout(this.fastResetTimer);

//         this.fastResetTimer = setTimeout(() => {
//           this.fastAdded = false;

//           if (this.isConnected) {
//             this.updateButtons();
//           }
//         }, FAST_PASS_RESET_DELAY);
//       }
//     }

//     message(text, error = false, showCart = false) {
//       this.status.textContent = text;
//       this.dataset.error = String(error);
//       this.cartLink.hidden = !showCart;
//     }

//     async request(url, options = {}) {
//       const controller = new AbortController();
//       const timer = setTimeout(() => controller.abort(), 20000);

//       try {
//         return await fetch(url, {
//           ...options,
//           signal: controller.signal
//         });
//       } finally {
//         clearTimeout(timer);
//       }
//     }

//     async addToCart(form) {
//       if (
//         this.busy ||
//         form.dataset.canBuy !== 'true' ||
//         form.closest('[inert]')
//       ) {
//         return;
//       }

//       // Membership cannot be added again while already in the cart.
//       // Fast Pass becomes available again after its success timer finishes.
//       if (
//         form === this.memberForm
//           ? (this.memberInCart || this.membershipChecking)
//           : this.fastAdded
//       ) {
//         return;
//       }

//       this.cartRevision++;
//       this.queued = null;

//       this.setBusy(true, form);
//       this.message('');

//       let added = false;
//       let rejected = false;

//       const root = this.cartRoot;

//       const emit = (name, detail) => {
//         document.documentElement.dispatchEvent(
//           new CustomEvent(name, {
//             bubbles: true,
//             detail
//           })
//         );
//       };

//       emit('theme:loading:start');

//       try {
//         // Ask Prestige which cart sections need updating.
//         const requested = [];

//         emit('cart:prepare-bundled-sections', {
//           sections: requested
//         });

//         const sections = [...new Set(requested)];
//         const payload = new FormData(form);

//         payload.set('sections', sections.join(','));

//         payload.set(
//           'sections_url',
//           `${root}variants/${payload.get('id')}`
//         );

//         const response = await this.request(`${root}cart/add.js`, {
//           method: 'POST',
//           body: payload,
//           headers: {
//             'X-Requested-With': 'XMLHttpRequest'
//           }
//         });

//         added = response.ok;
//         rejected = !response.ok;

//         if (added) {
//           this.cartRevision++;

//           if (form === this.memberForm) {
//             this.memberInCart = true;
//           }
//         }

//         const result = await response.json();

//         if (!response.ok) {
//           const description =
//             typeof result.description === 'string'
//               ? result.description
//               : 'This item could not be added. Please check its availability.';

//           form.dispatchEvent(
//             new CustomEvent('cart:error', {
//               bubbles: true,
//               detail: {
//                 error: description
//               }
//             })
//           );

//           throw new Error(description);
//         }

//         const cartResponse = await this.request(`${root}cart.js`);

//         if (!cartResponse.ok) {
//           throw new Error('Cart refresh failed.');
//         }

//         const cart = await cartResponse.json();

//         this.updateFromCart(cart);

//         cart.sections = result.sections || {};

//         // Retry section rendering if necessary; never repeat the add request.
//         for (const id of sections) {
//           if (
//             typeof cart.sections[id] !== 'string' ||
//             !cart.sections[id].trim()
//           ) {
//             const sectionResponse = await this.request(
//               `${root}?section_id=${encodeURIComponent(id)}`
//             );

//             if (!sectionResponse.ok) {
//               throw new Error('Cart section refresh failed.');
//             }

//             cart.sections[id] = await sectionResponse.text();
//           }

//           if (!cart.sections[id].trim()) {
//             throw new Error('Cart section was empty.');
//           }
//         }

//         const detail = {
//           items: Array.isArray(result.items)
//             ? result.items
//             : [result],
//           cart,
//           onSuccessDo: 'force_open_drawer'
//         };

//         // Preserve Prestige's normal cart and reward event flow.
//         form.dispatchEvent(
//           new CustomEvent('variant:add', {
//             bubbles: true,
//             detail
//           })
//         );

//         emit('cart:change', {
//           cart,
//           baseEvent: 'variant:add',
//           onSuccessDo: 'force_open_drawer'
//         });

//         this.message('Added to your cart.', false, true);
//       } catch (error) {
//         if (added) {
//           this.message(
//             'Added to your cart, but the cart display could not refresh. View your cart to continue.',
//             true,
//             true
//           );
//         } else if (rejected) {
//           this.message(error.message, true);
//         } else {
//           this.message(
//             'We couldn’t confirm the add. Check your cart before trying again.',
//             true,
//             true
//           );
//         }
//       } finally {
//         emit('theme:loading:end');

//         if (added && this.isConnected) {
//           this.showAddedState(form);
//         }

//         this.setBusy(false);

//         if (!added && this.isConnected) {
//           this.queueCartRead();
//         }
//       }
//     }
//   }

//   customElements.define('lgnd-offer-switcher', LGNDOfferSwitcher);
// })();

/* LGND offer switcher V4.
 * REPLACE the previous switcher code.
 * Do not add <script> tags or Liquid to your JavaScript asset.
 */
(() => {
  'use strict';

  if (customElements.get('lgnd-offer-switcher')) return;

  const MEMBER_SWITCH_DELAY = 2000;
  const FAST_PASS_RESET_DELAY = 1500;
  let instanceCount = 0;

  class LGNDOfferSwitcher extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.selected = this.dataset.selected || 'fast';
        this.busy = false;
        this.animating = false;
        this.animationRevision = 0;
        this.cardAnimations = [];
        this.memberInCart = false;
        this.membershipChecking = true;
        this.fastAdded = false;
        this.cartRevision = 0;

        this.tabs = [...this.querySelectorAll('[data-select]')];
        this.cards = [...this.querySelectorAll('[data-card]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.forms = [...this.querySelectorAll('[data-offer-form]')];
        this.status = this.querySelector('[data-status]');
        this.cartLink = this.querySelector('[data-cart-link]');

        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 1024px)');

        this.desktop.addEventListener(
          'change',
          () => this.handleLayoutChange(),
          options
        );

        this.memberForm = this.querySelector(
          '[data-panel="plus"] [data-offer-form]'
        );

        this.memberVariantId =
          this.memberForm.querySelector('[name="id"]').value;

        const prefix = `lgnd-offer-${++instanceCount}`;

        this.tabs.forEach(tab => {
          const panel = this.panels.find(
            item => item.dataset.panel === tab.dataset.select
          );

          tab.id = `${prefix}-${tab.dataset.select}-button`;
          panel.id = `${prefix}-${tab.dataset.select}-panel`;

          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'region');

          const heading = panel.querySelector('.lgnd-offers__offer-name');

          if (heading) {
            heading.id = `${prefix}-${tab.dataset.select}-heading`;
          }

          tab.addEventListener(
            'click',
            () => this.select(tab.dataset.select),
            options
          );
        });

        this.cards.forEach(card => {
          card.addEventListener(
            'click',
            () => this.select(card.dataset.card),
            options
          );
        });

        this.forms.forEach(form => {
          const label = form.querySelector('[data-button-label]');

          if (!label.dataset.idle) {
            label.dataset.idle = label.textContent;
          }

          form.addEventListener('submit', event => {
            event.preventDefault();
            this.addToCart(form);
          }, options);
        });

        this.setBusy(false);
        this.renderSelection();

        // Synchronize membership status with cart changes and removals.
        const onCartUpdate = event => {
          if (Array.isArray(event.detail?.cart?.items)) {
            this.updateFromCart(event.detail.cart);
          } else {
            this.queueCartRead();
          }
        };

        ['cart:change', 'variant:add', 'line-item:change'].forEach(name => {
          document.addEventListener(name, onCartUpdate, options);
        });

        ['cart:refresh', 'cart-drawer:refreshed'].forEach(name => {
          document.addEventListener(
            name,
            () => this.queueCartRead(),
            options
          );
        });

        window.addEventListener(
          'pageshow',
          () => this.queueCartRead(),
          options
        );

        this.readCart();
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;

      clearTimeout(this.memberSwitchTimer);
      clearTimeout(this.fastResetTimer);
      clearTimeout(this.cartReadTimer);

      this.cartRevision++;
      this.cancelCardAnimations();

      this.getAnimations({ subtree: true }).forEach(animation => {
        animation.cancel();
      });

      // An in-flight cart add is not aborted: it may already have succeeded.
    }

    cancelCardAnimations() {
      this.animationRevision++;

      this.cardAnimations?.forEach(animation => animation.cancel());

      this.cardAnimations = [];
      this.animating = false;
      this.queued = null;
    }

    handleLayoutChange() {
      const focused = document.activeElement;

      const focusedPanel = this.panels.find(panel => {
        return panel.contains(focused);
      });

      const focusedSelector = [...this.tabs, ...this.cards].find(item => {
        return item === focused;
      });

      this.cancelCardAnimations();

      if (this.desktop.matches) {
        clearTimeout(this.memberSwitchTimer);
      } else {
        // Keep the focused/in-flight purchase visible when the screen narrows.
        const activePanel = this.activeForm?.closest('[data-panel]');

        this.selected =
          (focusedPanel || activePanel)?.dataset.panel || this.selected;
      }

      this.renderSelection();

      if (this.desktop.matches && focusedSelector) {
        const key =
          focusedSelector.dataset.select || focusedSelector.dataset.card;

        this.panels
          .find(panel => panel.dataset.panel === key)
          ?.querySelector('.lgnd-offers__offer-name')
          ?.focus({ preventScroll: true });
      }
    }

    renderSelection() {
      this.dataset.selected = this.selected;

      this.tabs.forEach(tab => {
        tab.setAttribute(
          'aria-pressed',
          String(tab.dataset.select === this.selected)
        );
      });

      this.cards.forEach(card => {
        const active = card.dataset.card === this.selected;

        card.dataset.front = String(active);
        card.setAttribute('aria-pressed', String(active));
      });

      this.panels.forEach(panel => {
        // Desktop exposes both offers; mobile exposes the selected offer.
        const active =
          this.desktop.matches || panel.dataset.panel === this.selected;

        panel.inert = !active;
        panel.setAttribute('aria-hidden', String(!active));

        const heading = panel.querySelector('.lgnd-offers__offer-name');

        const tab = this.tabs.find(item => {
          return item.dataset.select === panel.dataset.panel;
        });

        panel.setAttribute(
          'aria-labelledby',
          this.desktop.matches && heading ? heading.id : tab.id
        );
      });
    }

    async select(next, automatic = false) {
      if (!automatic) clearTimeout(this.memberSwitchTimer);

      if (
        this.desktop.matches ||
        this.busy ||
        !['fast', 'plus'].includes(next)
      ) return;

      if (this.animating) {
        this.queued = next;
        return;
      }

      if (next === this.selected) return;

      this.message('');

      const outgoing = this.cards.find(card => {
        return card.dataset.card === this.selected;
      });

      const incoming = this.cards.find(card => {
        return card.dataset.card === next;
      });

      const oldFront = getComputedStyle(outgoing).transform;
      const oldBack = getComputedStyle(incoming).transform;

      const distance =
        this.getBoundingClientRect().right -
        outgoing.getBoundingClientRect().left +
        outgoing.offsetWidth;

      const outside =
        `translate(${distance}px, -50%) rotate(15deg) scale(.94)`;

      this.animating = true;

      const animations = [];
      this.cardAnimations = animations;
      const revision = ++this.animationRevision;

      try {
        this.selected = next;
        this.dataset.selected = next;

        this.tabs.forEach(tab => {
          tab.setAttribute(
            'aria-pressed',
            String(tab.dataset.select === next)
          );
        });

        this.panels.forEach(panel => {
          panel.inert = panel.dataset.panel !== next;

          panel.setAttribute(
            'aria-hidden',
            String(panel.dataset.panel !== next)
          );
        });

        if (this.motion.matches || !outgoing.animate) {
          this.renderSelection();
          return;
        }

        const out = outgoing.animate(
          [{ transform: oldFront }, { transform: outside }],
          {
            duration: 250,
            easing: 'cubic-bezier(.5,0,.8,.5)',
            fill: 'forwards'
          }
        );

        animations.push(out);
        await out.finished;

        if (revision !== this.animationRevision) return;

        this.renderSelection();
        out.cancel();

        const rear = getComputedStyle(outgoing).transform;
        const front = getComputedStyle(incoming).transform;

        const backIn = outgoing.animate(
          [{ transform: outside }, { transform: rear }],
          {
            duration: 350,
            easing: 'cubic-bezier(.2,.8,.2,1)'
          }
        );

        const forward = incoming.animate(
          [
            { transform: oldBack, filter: 'brightness(.65)' },
            { transform: front, filter: 'brightness(1)' }
          ],
          {
            duration: 350,
            easing: 'cubic-bezier(.2,.8,.2,1)'
          }
        );

        animations.push(backIn, forward);
        await Promise.all([backIn.finished, forward.finished]);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('LGND card animation:', error);
        }
      } finally {
        animations.forEach(animation => animation.cancel());

        if (revision === this.animationRevision) {
          this.cardAnimations = [];
          this.renderSelection();
          this.animating = false;

          const queued = this.queued;
          this.queued = null;

          if (queued && this.isConnected) this.select(queued);
        }
      }
    }

    setBusy(busy, activeForm) {
      this.busy = busy;
      this.activeForm = busy ? activeForm : null;

      this.tabs.forEach(tab => {
        tab.disabled = busy;
      });

      this.cards.forEach(card => {
        card.disabled = busy;
      });

      this.updateButtons();
    }

    updateButtons() {
      this.forms.forEach(form => {
        const button = form.querySelector('[type="submit"]');
        const label = button.querySelector('[data-button-label]');

        const membership = form === this.memberForm;
        const loading = this.busy && form === this.activeForm;
        const added = membership ? this.memberInCart : this.fastAdded;

        const text = loading
          ? 'Adding'
          : added
            ? 'Added to Cart'
            : label.dataset.idle;

        button.disabled =
          this.busy ||
          added ||
          form.dataset.canBuy !== 'true' ||
          (membership && this.membershipChecking);

        button.setAttribute('aria-busy', String(loading));
        button.style.opacity = added && !loading ? '1' : '';

        const arrow = button.lastElementChild;

        if (arrow !== label) {
          arrow.hidden = loading || added;
        }

        const state = `${loading}:${text}`;

        if (label.dataset.state === state) return;

        label.dataset.state = state;
        label.spinnerAnimation?.cancel();
        label.textContent = '';

        if (loading) {
          const spinner = document.createElement('span');

          spinner.setAttribute('aria-hidden', 'true');
          spinner.dataset.offerSpinner = '';

          spinner.style.cssText =
            'display:inline-block;width:14px;height:14px;' +
            'margin-right:9px;vertical-align:-2px;' +
            'border:2px solid currentColor;' +
            'border-right-color:transparent;border-radius:50%;';

          label.append(spinner);

          if (!this.motion.matches) {
            label.spinnerAnimation = spinner.animate(
              [
                { transform: 'rotate(0deg)' },
                { transform: 'rotate(360deg)' }
              ],
              {
                duration: 650,
                iterations: Infinity,
                easing: 'linear'
              }
            );
          }
        }

        label.append(document.createTextNode(text));
      });
    }

    get cartRoot() {
      return (
        window.Shopify?.routes?.root ||
        this.dataset.root ||
        '/'
      ).replace(/\/?$/, '/');
    }

    updateFromCart(cart) {
      if (!Array.isArray(cart?.items)) return;

      this.cartRevision++;
      this.membershipChecking = false;

      this.memberInCart = cart.items.some(item => {
        return (
          String(item.variant_id ?? item.id) === this.memberVariantId &&
          Number(item.quantity ?? 1) > 0
        );
      });

      if (!this.memberInCart) {
        clearTimeout(this.memberSwitchTimer);
      }

      this.updateButtons();
    }

    queueCartRead() {
      clearTimeout(this.cartReadTimer);
      this.cartReadTimer = setTimeout(() => this.readCart(), 100);
    }

    async readCart() {
      const revision = ++this.cartRevision;

      try {
        const response = await this.request(
          `${this.cartRoot}cart.js`,
          { cache: 'no-store' }
        );

        if (!response.ok) throw new Error('Cart lookup failed.');

        const cart = await response.json();

        if (this.isConnected && revision === this.cartRevision) {
          this.updateFromCart(cart);
        }
      } catch (error) {
        // Preserve the last known state if the lookup is unavailable.
      } finally {
        if (this.isConnected && revision === this.cartRevision) {
          this.membershipChecking = false;
          this.updateButtons();
        }
      }
    }

    showAddedState(form) {
      if (form === this.memberForm) {
        clearTimeout(this.memberSwitchTimer);

        // Auto-switch only when using the mobile toggle layout.
        if (this.memberInCart && !this.desktop.matches) {
          this.memberSwitchTimer = setTimeout(() => {
            if (
              this.isConnected &&
              !this.desktop.matches &&
              this.memberInCart &&
              this.selected === 'plus'
            ) {
              this.select('fast', true);
            }
          }, MEMBER_SWITCH_DELAY);
        }
      } else {
        this.fastAdded = true;
        clearTimeout(this.fastResetTimer);

        this.fastResetTimer = setTimeout(() => {
          this.fastAdded = false;

          if (this.isConnected) this.updateButtons();
        }, FAST_PASS_RESET_DELAY);
      }
    }

    message(text, error = false, showCart = false) {
      this.status.textContent = text;
      this.dataset.error = String(error);
      this.cartLink.hidden = !showCart;
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);

      try {
        return await fetch(url, {
          ...options,
          signal: controller.signal
        });
      } finally {
        clearTimeout(timer);
      }
    }

    


    // Apply Offer Discount


    getCartDiscountCodes(cart, appliedOnly = false) {
  const codes = (cart.discount_codes || [])
    .filter(item => !appliedOnly || item.applicable === true)
    .map(item => typeof item === 'string' ? item : item.code);

  const applications = [
    ...(cart.cart_level_discount_applications || []),
    ...(cart.items || []).flatMap(item =>
      [
        ...(item.line_level_discount_allocations || []),
        ...(item.discount_allocations || [])
      ].map(allocation => allocation.discount_application)
    )
  ];

  applications.forEach(application => {
    if (application?.type === 'discount_code') {
      codes.push(application.title);
    }
  });

  return [...new Map(
    codes
      .filter(code => typeof code === 'string' && code.trim())
      .map(code => [code.trim().toLowerCase(), code.trim()])
  ).values()];
}

async applyOfferDiscount(form, cart, sections) {
  const code = (form.dataset.discountCode || '').trim();

  // No setting in the HTML: skip the discount update entirely.
  if (!code) {
    return { cart, sections: null, notice: '' };
  }

  // Include existing codes rather than replacing them with only the promo.
  const codes = new Map(
    [...this.getCartDiscountCodes(cart), code].map(value =>
      [value.toLowerCase(), value]
    )
  );

  let updated = cart;
  let notice = '';

  try {
    const response = await this.request(
      `${this.cartRoot}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          discount: [...codes.values()].join(','),
          sections,
          sections_url: `${this.cartRoot}cart`
        })
      }
    );

    if (!response.ok) {
      throw new Error('Discount update failed.');
    }

    const nextCart = await response.json();

    if (!Array.isArray(nextCart.items)) {
      throw new Error('Invalid cart response.');
    }

    updated = nextCart;

    const applied = this.getCartDiscountCodes(updated, true);

    if (!applied.some(value =>
      value.toLowerCase() === code.toLowerCase()
    )) {
      notice = `Added to your cart, but ${code} could not be confirmed. Check the discount before checkout.`;
    }
  } catch (error) {
    notice = `Added to your cart, but ${code} could not be confirmed. Check the discount before checkout.`;

    // Read the cart again without repeating either mutation.
    try {
      const response = await this.request(
        `${this.cartRoot}cart.js`,
        { cache: 'no-store' }
      );

      if (response.ok) {
        const latest = await response.json();

        if (Array.isArray(latest.items)) {
          updated = latest;
        }
      }
    } catch (refreshError) {
      // Keep the last known cart and display the confirmation message.
    }
  }

  if (this.getCartDiscountCodes(updated, true).some(value =>
    value.toLowerCase() === code.toLowerCase()
  )) {
    notice = '';
  }

  // Use post-discount sections, or let the existing section fallback fetch them.
  return {
    cart: updated,
    sections: updated.sections || {},
    notice
  };
}

    async addToCart(form) {
      if (
        this.busy ||
        form.dataset.canBuy !== 'true' ||
        form.closest('[inert]')
      ) return;

      if (
        form === this.memberForm
          ? (this.memberInCart || this.membershipChecking)
          : this.fastAdded
      ) return;

      this.cartRevision++;
      this.queued = null;

      if (this.desktop.matches) {
        this.selected = form.closest('[data-panel]').dataset.panel;
        this.renderSelection();
      }

      this.setBusy(true, form);
      this.message('');

      let added = false;
      let rejected = false;
      const root = this.cartRoot;

      const emit = (name, detail) => {
        document.documentElement.dispatchEvent(
          new CustomEvent(name, { bubbles: true, detail })
        );
      };

      emit('theme:loading:start');

      try {
        // Preserve Prestige's bundled-section and cart-event flow.
        const requested = [];

        emit('cart:prepare-bundled-sections', {
          sections: requested
        });

        const sections = [...new Set(requested)];
        const payload = new FormData(form);

        payload.set('sections', sections.join(','));
        payload.set(
          'sections_url',
          `${root}variants/${payload.get('id')}`
        );

        const response = await this.request(`${root}cart/add.js`, {
          method: 'POST',
          body: payload,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        added = response.ok;
        rejected = !response.ok;

        if (added) {
          this.cartRevision++;

          if (form === this.memberForm) {
            this.memberInCart = true;
          }
        }

        const result = await response.json();

        if (!response.ok) {
          const description =
            typeof result.description === 'string'
              ? result.description
              : 'This item could not be added. Please check its availability.';

          form.dispatchEvent(
            new CustomEvent('cart:error', {
              bubbles: true,
              detail: { error: description }
            })
          );

          throw new Error(description);
        }

        const cartResponse = await this.request(`${root}cart.js`);

        if (!cartResponse.ok) {
          throw new Error('Cart refresh failed.');
        }

        const offer = await this.applyOfferDiscount(
  form,
  await cartResponse.json(),
  sections
);

const cart = offer.cart;

this.updateFromCart(cart);
cart.sections = offer.sections ?? result.sections ?? {};

        // Retry section rendering if needed, never the purchase request.
        for (const id of sections) {
          if (
            typeof cart.sections[id] !== 'string' ||
            !cart.sections[id].trim()
          ) {
            const sectionResponse = await this.request(
              `${root}?section_id=${encodeURIComponent(id)}`
            );

            if (!sectionResponse.ok) {
              throw new Error('Cart section refresh failed.');
            }

            cart.sections[id] = await sectionResponse.text();
          }

          if (!cart.sections[id].trim()) {
            throw new Error('Cart section was empty.');
          }
        }

        const detail = {
          items: Array.isArray(result.items) ? result.items : [result],
          cart,
          onSuccessDo: 'force_open_drawer'
        };

        form.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail
          })
        );

        emit('cart:change', {
          cart,
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer'
        });

        this.message(
  offer.notice || 'Added to your cart.',
  Boolean(offer.notice),
  true
);
      } catch (error) {
        if (added) {
          this.message(
            'Added to your cart, but the cart display could not refresh. View your cart to continue.',
            true,
            true
          );
        } else if (rejected) {
          this.message(error.message, true);
        } else {
          this.message(
            'We couldn’t confirm the add. Check your cart before trying again.',
            true,
            true
          );
        }
      } finally {
        emit('theme:loading:end');

        if (added && this.isConnected) {
          this.showAddedState(form);
        }

        this.setBusy(false);

        if (!added && this.isConnected) {
          this.queueCartRead();
        }
      }
    }
  }

  customElements.define('lgnd-offer-switcher', LGNDOfferSwitcher);
})();

/*
 * ============================================================================
 * 7. LGND+ MEMBERS BONUS STRIP
 * ============================================================================
 *
 * Powers the "Join LGND+" button in the homepage Members Bonus strip.
 *
 * - LGND+ not in cart: adds it (4-week selling plan) and opens the cart drawer.
 * - LGND+ already in cart: just opens the cart drawer.
 *
 * Uses the same Prestige cart events as the offer switcher, so the switcher's
 * LGND+ card updates to "Added to Cart" when the strip adds it (and the strip
 * updates when the switcher adds it).
 *
 * Safe to leave in place after the strip is removed: nothing runs unless
 * [data-lmb-strip] is on the page.
 */
(function () {
  'use strict';

  const STRIP_SELECTOR = '[data-lmb-strip]';

  function emit(name, detail) {
    document.documentElement.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail })
    );
  }

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);

    try {
      return await fetch(url, { ...options, signal: controller.signal });
    } finally {
      clearTimeout(timer);
    }
  }

  function openCartDrawer(root) {
    const drawer = document.querySelector('cart-drawer, #cart-drawer');

    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
      return;
    }

    const toggle = document.querySelector('[aria-controls="cart-drawer"]');

    if (toggle) {
      toggle.click();
      return;
    }

    window.location.href = `${root}cart`;
  }

  function initStrip(strip) {
    if (strip.dataset.lmbReady === 'true') return;
    strip.dataset.lmbReady = 'true';

    // Logged-in members see no button, so there is nothing to wire up.
    const form = strip.querySelector('[data-lmb-form]');
    if (!form) return;

    const button = form.querySelector('[type="submit"]');
    const label = form.querySelector('[data-lmb-label]');
    const status = strip.querySelector('[data-lmb-status]');
    const variantId = String(form.querySelector('[name="id"]').value);
    const idleText = label.textContent.trim();
    const canBuy = form.dataset.canBuy === 'true';

    const root = (
      window.Shopify?.routes?.root ||
      strip.dataset.root ||
      '/'
    ).replace(/\/?$/, '/');

    let busy = false;
    let inCart = false;
    let revision = 0;
    let readTimer = null;

    function render() {
      button.disabled = busy || (!canBuy && !inCart);
      button.setAttribute('aria-busy', String(busy));
      strip.dataset.inCart = String(inCart);

      label.textContent = '';

      if (busy) {
        const spinner = document.createElement('span');
        spinner.className = 'lmb__spinner';
        spinner.setAttribute('aria-hidden', 'true');
        label.append(spinner, document.createTextNode('Adding'));
        return;
      }

      label.textContent = inCart
        ? 'In Your Cart'
        : canBuy
          ? idleText
          : 'Unavailable';
    }

    function message(text, error = false, showCart = false) {
      if (!status) return;

      status.textContent = text;
      strip.dataset.error = String(error);

      if (showCart && text) {
        const link = document.createElement('a');
        link.href = `${root}cart`;
        link.textContent = 'View your cart';
        status.append(' ', link);
      }
    }

    function updateFromCart(cart) {
      if (!Array.isArray(cart?.items)) return;

      inCart = cart.items.some(item => {
        return (
          String(item.variant_id ?? item.id) === variantId &&
          Number(item.quantity ?? 1) > 0
        );
      });

      render();
    }

    async function readCart() {
      const current = ++revision;

      try {
        const response = await request(`${root}cart.js`, { cache: 'no-store' });
        if (!response.ok) return;

        const cart = await response.json();

        if (current === revision) updateFromCart(cart);
      } catch (error) {
        // Keep the last known state if the cart can't be read.
      }
    }

    function queueRead() {
      clearTimeout(readTimer);
      readTimer = setTimeout(readCart, 100);
    }

    // Stay in sync with every cart change on the page (drawer, switcher, etc).
    ['cart:change', 'variant:add', 'line-item:change'].forEach(name => {
      document.addEventListener(name, event => {
        if (busy) return;

        if (Array.isArray(event.detail?.cart?.items)) {
          revision++;
          updateFromCart(event.detail.cart);
        } else {
          queueRead();
        }
      });
    });

    ['cart:refresh', 'cart-drawer:refreshed'].forEach(name => {
      document.addEventListener(name, queueRead);
    });

    window.addEventListener('pageshow', queueRead);

    form.addEventListener('submit', async event => {
      event.preventDefault();

      if (busy) return;

      if (inCart) {
        openCartDrawer(root);
        return;
      }

      if (!canBuy) return;

      busy = true;
      revision++;
      render();
      message('');

      let added = false;
      let rejected = false;

      emit('theme:loading:start');

      try {
        // Re-check the cart first so a second membership is never added
        // (another tab, or a click before the first cart read finished).
        const check = await request(`${root}cart.js`, { cache: 'no-store' });

        if (check.ok) {
          const current = await check.json();

          if (Array.isArray(current.items)) {
            inCart = current.items.some(item => {
              return String(item.variant_id ?? item.id) === variantId;
            });

            if (inCart) {
              openCartDrawer(root);
              return;
            }
          }
        }

        // Ask Prestige which cart sections need re-rendering.
        const requested = [];
        emit('cart:prepare-bundled-sections', { sections: requested });

        const sections = [...new Set(requested)];
        const payload = new FormData(form);

        payload.set('sections', sections.join(','));
        payload.set('sections_url', `${root}variants/${payload.get('id')}`);

        const response = await request(`${root}cart/add.js`, {
          method: 'POST',
          body: payload,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        added = response.ok;
        rejected = !response.ok;

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            typeof result.description === 'string'
              ? result.description
              : 'LGND+ could not be added. Please try again.'
          );
        }

        inCart = true;

        const cartResponse = await request(`${root}cart.js`, { cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('Cart refresh failed.');

        const cart = await cartResponse.json();
        cart.sections = result.sections || {};

        // Retry section rendering if needed, never the add itself.
        for (const id of sections) {
          if (
            typeof cart.sections[id] !== 'string' ||
            !cart.sections[id].trim()
          ) {
            const sectionResponse = await request(
              `${root}?section_id=${encodeURIComponent(id)}`
            );

            if (!sectionResponse.ok) {
              throw new Error('Cart section refresh failed.');
            }

            cart.sections[id] = await sectionResponse.text();
          }
        }

        updateFromCart(cart);

        const detail = {
          items: Array.isArray(result.items) ? result.items : [result],
          cart,
          onSuccessDo: 'force_open_drawer'
        };

        form.dispatchEvent(
          new CustomEvent('variant:add', { bubbles: true, detail })
        );

        emit('cart:change', {
          cart,
          baseEvent: 'variant:add',
          onSuccessDo: 'force_open_drawer'
        });
      } catch (error) {
        if (added) {
          message('LGND+ was added, but the cart could not refresh.', true, true);
        } else if (rejected) {
          message(error.message, true);
        } else {
          message('We couldn’t confirm the add. Check your cart before trying again.', true, true);
        }
      } finally {
        emit('theme:loading:end');
        busy = false;
        render();

        if (!added) queueRead();
      }
    });

    render();
    readCart();
  }

  function start() {
    document.querySelectorAll(STRIP_SELECTOR).forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();


/*
 * ============================================================================
 * 8. LGND+ MEMBERS BONUS COUNTDOWN
 * ============================================================================
 *
 * Turns any element with [data-lmb-countdown] into a live countdown to its
 * data-ends time (ISO with offset, e.g. 2026-10-11T23:59:59-04:00).
 *
 *   More than 24 hours left:  ENDS IN 2 DAYS 5 HOURS!
 *   24 hours or less:         ENDS IN 5 HRS 12 MINS!
 *   Final hour:               ENDS IN 42 MINUTES!
 *   After the end:            ENDED
 *
 * Before data-starts, the element keeps its original text (MEMBERS BONUS).
 * Zero parts are dropped ("ENDS IN 2 DAYS!" rather than "2 DAYS 0 HOURS").
 * Safe if no countdown is on the page: nothing runs.
 */
(function () {
  'use strict';

  const SELECTOR = '[data-lmb-countdown]';
  const MINUTE = 60 * 1000;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  const unit = (value, one, many) => `${value} ${value === 1 ? one : many}`;

  function join(first, second) {
    return second ? `${first} ${second}` : first;
  }

  function countdownText(remaining) {
    // More than 24 hours: days + hours.
    if (remaining > DAY) {
      const days = Math.floor(remaining / DAY);
      const hours = Math.floor((remaining % DAY) / HOUR);

      return `ENDS IN ${join(
        unit(days, 'DAY', 'DAYS'),
        hours ? unit(hours, 'HOUR', 'HOURS') : ''
      )}!`;
    }

    // 24 hours or less: hours + minutes.
    if (remaining > HOUR) {
      const hours = Math.floor(remaining / HOUR);
      const minutes = Math.floor((remaining % HOUR) / MINUTE);

      return `ENDS IN ${join(
        unit(hours, 'HR', 'HRS'),
        minutes ? unit(minutes, 'MIN', 'MINS') : ''
      )}!`;
    }

    // Final hour: minutes only (rounded up, so it never shows 0).
    const minutes = Math.max(1, Math.ceil(remaining / MINUTE));

    return `ENDS IN ${unit(minutes, 'MINUTE', 'MINUTES')}!`;
  }

  const items = new Set();
  let timer = null;

  function tick() {
    const now = Date.now();

    items.forEach(element => {
      if (!element.isConnected) {
        items.delete(element);
        return;
      }

      const start = Date.parse(element.dataset.starts || '') || 0;
      const end = Date.parse(element.dataset.ends || '');

      if (!end) return;

      let text;
      let state;

      if (now < start) {
        text = element.dataset.idleText;
        state = 'upcoming';
      } else if (now >= end) {
        text = element.dataset.endedText || 'ENDED';
        state = 'ended';
      } else {
        text = countdownText(end - now);
        state = 'live';
      }

      if (element.textContent !== text) element.textContent = text;
      if (element.dataset.state !== state) element.dataset.state = state;
    });

    if (!items.size) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    document.querySelectorAll(SELECTOR).forEach(element => {
      if (!element.dataset.idleText) {
        element.dataset.idleText = element.textContent.trim();
      }

      items.add(element);
    });

    if (!items.size) return;

    tick();

    if (!timer) timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  // Catch up immediately when a backgrounded tab becomes visible again.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && items.size) tick();
  });
})();


/*
 * ============================================================================
 * 9. LGND+ MEMBERS BONUS REVEAL (A/B VARIANT B)
 * ============================================================================
 *
 * For strips marked [data-lmb-reveal]:
 *
 *   Desktop (1024px+, no toggle): always open.
 *   Below 1024px, follows the offer switcher toggle:
 *     LGND+ selected     -> data-revealed="true"  (CSS slides the strip open)
 *     Fast Pass selected -> data-revealed="false" (CSS slides it closed)
 *
 * The switcher's own data-selected attribute is the source of truth, so this
 * also follows its auto-switch back to Fast Pass after LGND+ is added.
 *
 * Collapsed strips are inert, so their buttons can't be tabbed to.
 * Fires a bubbling "lmb:revealed" event each time a strip opens from a
 * toggle tap (not on desktop page load), for A/B tracking.
 *
 * Does nothing on pages without a [data-lmb-reveal] strip, so the live
 * homepage (variant A) is unaffected.
 */
(function () {
  'use strict';

  const SELECTOR = '[data-lmb-reveal]';
  const desktop = matchMedia('(min-width: 1024px)');
  const observed = new WeakSet();
  const doneTimers = new WeakMap();

  function setOpen(strip, open) {
    const wasOpen = strip.dataset.revealed === 'true';
    if (open === wasOpen && strip.dataset.revealed) return;

    strip.dataset.revealed = String(open);

    const panel = strip.querySelector('.lmb__reveal');
    if (panel) panel.inert = !open;

    clearTimeout(doneTimers.get(strip));

    if (open) {
      // Let the glasses cutouts overflow only after the slide finishes.
      doneTimers.set(strip, setTimeout(() => {
        strip.dataset.revealDone = 'true';
      }, 500));

      if (!wasOpen && !desktop.matches) {
        strip.dispatchEvent(new CustomEvent('lmb:revealed', { bubbles: true }));
      }
    } else {
      strip.dataset.revealDone = 'false';
    }
  }

  function plusSelected() {
    return [...document.querySelectorAll('lgnd-offer-switcher')].some(
      switcher => switcher.dataset.selected === 'plus'
    );
  }

  function sync() {
    const open = desktop.matches || plusSelected();
    document.querySelectorAll(SELECTOR).forEach(strip => setOpen(strip, open));
  }

  const observer = new MutationObserver(sync);

  desktop.addEventListener('change', () => {
    if (document.querySelector(SELECTOR)) sync();
  });

  function start() {
    if (!document.querySelector(SELECTOR)) return;

    document.querySelectorAll('lgnd-offer-switcher').forEach(switcher => {
      if (observed.has(switcher)) return;

      observed.add(switcher);
      observer.observe(switcher, {
        attributes: true,
        attributeFilter: ['data-selected']
      });
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();